import {
    useEffect,
    useState
} from "react";
import { getMyApiKeys } from "./services";

export function useMyApiKeys(timestamp=0) {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(function () {
        setLoading(true);
        getMyApiKeys()
            .then(function (response) {
                setLoading(false);
                setData(response.data);
            })
            .catch(function (error) {
                setLoading(false);
                setError(error);
            });
    }, [timestamp]);

    return [loading, data, error];
}